<!--
 * @Author: jian.li jian.li@genetronhealth.com
 * @Date: 2022-11-17 15:56:30
 * @LastEditors: jian.li jian.li@genetronhealth.com
 * @LastEditTime: 2022-11-17 15:58:39
 * @FilePath: \FSZ-GALILEO-WEB\genetron-web\genetron-h5\src\App.vue
 * @Description: 
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { disabledScale } from "@/utils/disableScale";
// import VConsole from "vconsole";
// let vConsole = new VConsole();
export default {
  mounted(){
    disabledScale()
  }
}
</script>
<style lang="less">
//测试ide
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
    font-family: @family;
  
}
html{
  background: #fff;
    font-family: @family;

}

</style>
